<script setup lang="ts">
  import { useField } from 'vee-validate';
  import { toRef, toRefs } from 'vue';
  import Select from './Select.vue';
  import type { SelectFieldProps, SelectModelValue } from './Select.types';

  const props = withDefaults(defineProps<SelectFieldProps>(), {
    internalSearch: true,
  });

  const emit = defineEmits<{
    'update:modelValue': [value: SelectModelValue];
  }>();

  const { name: inputName, label, rules, ...rest } = toRefs(props);
  const inputProps = toRef(rest);

  const {
    value: inputValue,
    errorMessage,
    handleBlur,
    handleChange,
    meta,
  } = useField<SelectModelValue>(inputName.value, rules?.value, {
    label: label?.value,
  });

  const onUpdateModelValue = (value: SelectModelValue) => {
    handleChange(value);
    emit('update:modelValue', value);
  };
</script>

<template>
  <Select
    v-bind="inputProps"
    :name="name"
    :label="label"
    :meta="meta"
    :error="errorMessage"
    :model-value="inputValue"
    @blur="handleBlur"
    @update:model-value="onUpdateModelValue"
  >
    <template v-if="$slots.empty" #empty><slot name="empty" /></template>
    <template v-if="$slots.noResults" #noResults
      ><slot name="noResults" /></template
    >
    <template v-if="$slots.extraLabel" #extraLabel
      ><slot name="extraLabel" /></template
    >
    <template v-if="$slots.labelTrailing" #labelTrailing
      ><slot name="labelTrailing" /></template
    >
  </Select>
</template>
